import { IGetPublishTermsResponseData, ITermSchema } from '../internalTypes';
import { getServiceId } from './getServiceId';

const SERVICE_ORDER = ['servicePackage', 'top3', 'premium+highlight', 'premium', 'paid+highlight', 'paid', 'free'];

export function getServices(data: IGetPublishTermsResponseData): ITermSchema[] {
  const { terms } = data;

  if (!terms) {
    return [];
  }

  return SERVICE_ORDER.reduce((acc, serviceId) => {
    const term = terms.find(term => getServiceId(term) === serviceId);

    if (term) {
      acc.push(term);
    }

    return acc;
  }, [] as ITermSchema[]);
}
